<template>
  <div>
    <v-row>
      <v-col cols="12" md="4" sm="3" v-if="!(['supplier_agri-input'].indexOf(userType)>-1)">
        <v-sheet
            color="white"
            elevation="1"
            height="100"
            width="100%"
        >
          <v-list-item tag="a" to="/beeshop/agri-input/reporting/stock-report/nowebview">
            <v-list-item-avatar>
              <font-awesome-icon style="font-size: 50px; color: teal" icon="box"/>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title><h2>{{$t('stockReport')}}</h2></v-list-item-title>
              <v-list-item-subtitle>{{$t('stockReportDesc')}}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-sheet>
      </v-col>

      <!--
      <v-col cols="12" md="4" sm="3" v-if="['employee','supplier_agri-input'].indexOf(userType)>-1">
        <v-sheet
            color="white"
            elevation="1"
            height="100"
            width="100%"
        >
          <v-list-item tag="a" to="/beeshop/agri-input/reporting/supplier-stock-report/nowebview">
            <v-list-item-avatar>
              <font-awesome-icon style="font-size: 50px; color: pink" icon="parachute-box"/>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title><h2>{{$t('supplierStockReport')}}</h2></v-list-item-title>
              <v-list-item-subtitle>{{$t('supplierStockReportDesc')}}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-sheet>
      </v-col> -->

      <v-col cols="12" md="4" sm="3" style="cursor: pointer" v-if="!(['supplier_agri-input'].indexOf(userType)>-1)">
        <v-sheet
            color="white"
            elevation="1"
            height="100"
            width="100%"
        >
          <v-list-item tage="a" to="/beeshop/agri-input/reporting/stock-detail-report/nowebview">
            <v-list-item-avatar>
              <font-awesome-icon style="font-size: 50px; color: yellowgreen" icon="stream"/>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title><h2>{{$t('stockDetailReport')}}</h2></v-list-item-title>
              <v-list-item-subtitle>{{$t('stockDetailReportDesc')}}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-sheet>
      </v-col>

      <v-col cols="12" md="4" sm="3">
        <v-sheet
          color="white"
          elevation="1"
          height="100"
          width="100%"
        >
          <v-list-item tage="a" to="/beeshop/agri-input/reporting/payment-list-report/nowebview">
            <v-list-item-avatar>
              <font-awesome-icon style="font-size: 50px; color: green" icon="money-bill-alt"/>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title><h2>{{$t('paymentListReport')}}</h2></v-list-item-title>
              <v-list-item-subtitle>{{$t('paymentListReportDesc')}}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-sheet>
      </v-col>
      
      <v-col cols="12" md="4" sm="3">
        <v-sheet
          color="white"
          elevation="1"
          height="100"
          width="100%"
        >
          <v-list-item tage="a" to="/beeshop/agri-input/reporting/payment-report/nowebview">
            <v-list-item-avatar>
              <font-awesome-icon style="font-size: 50px; color: #FFCC00" icon="dollar-sign"/>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title><h2>{{$t('paymentReport')}}</h2></v-list-item-title>
              <v-list-item-subtitle>{{$t('paymentReportDesc')}}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-sheet>
      </v-col>

      <v-col cols="12" md="4" sm="3">
        <v-sheet
          color="white"
          elevation="1"
          height="100"
          width="100%"
        >
          <v-list-item tage="a" to="/beeshop/agri-input/reporting/sale-transaction-report/nowebview">
            <v-list-item-avatar>
              <font-awesome-icon style="font-size: 50px; color: teal" icon="shopping-basket"/>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title><h2>{{$t('saleTransactionReport')}}</h2></v-list-item-title>
              <v-list-item-subtitle>{{$t('saleTransactionReportDesc')}}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-sheet>
      </v-col>

      <v-col cols="12" md="4" sm="3">
        <v-sheet
          color="white"
          elevation="1"
          height="100"
          width="100%"
        >
          <v-list-item tage="a" to="/beeshop/agri-input/reporting/stock-balance-report/nowebview">
            <v-list-item-avatar>
              <font-awesome-icon style="font-size: 50px; color: olive" icon="cubes"/>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title><h2>{{$t('stockBalanceReport')}}</h2></v-list-item-title>
              <v-list-item-subtitle>{{$t('stockBalanceReportDesc')}}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-sheet>
      </v-col>

      <!-- <v-col cols="12" md="4" sm="3">
        <v-sheet
            color="white"
            elevation="1"
            height="100"
            width="100%"
        >
          <v-list-item tag="a" to="/bee-po-report/nowebview">
            <v-list-item-avatar>
              <font-awesome-icon style="font-size: 50px; color: lightgreen" icon="shopping-cart"/>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title><h2>{{$t('poReport')}}</h2></v-list-item-title>
              <v-list-item-subtitle>{{$t('poReportDesc')}}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-sheet>
      </v-col> -->

      <!-- <v-col cols="12" md="4" sm="3">
        <v-sheet
            color="white"
            elevation="1"
            height="100"
            width="100%"
        >
          <v-list-item tag="a" to="/bee-sale-report/nowebview">
            <v-list-item-avatar>
              <font-awesome-icon style="font-size: 50px; color: blue" icon="shopping-basket"/>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title><h2>{{$t('saleReport')}}</h2></v-list-item-title>
              <v-list-item-subtitle>{{$t('saleReportDesc')}}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-sheet>
      </v-col> -->
    </v-row>

  </div>
</template>
<script>
export default {
  name: "Report",
  data() {
    return {
      userType:localStorage.type
    };
  },
  methods:{
    goToRoute(url){
      let vm=this;
      vm.$router.replace({path:url});
    }
  }
};
</script>
